import React, { useContext } from "react";
import styles from "./NavigationMenu.module.css";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { NotificationContext } from "../../createContext/Notification/NotificationContext";
import stadium from "../images/stadium.png";
import communities from "../images/communities.png";

const menuItems = [
  { icon: "🏠", label: "Home", ariaLabel: "Home", routePath: "home" },
  { icon: "🔍", label: "Search", ariaLabel: "Search", routePath: "Search" },
  {
    icon: "🔔",
    label: "Notification",
    ariaLabel: "Notifications",
    routePath: "notification",
    mode: "mobile",
  },
  {
    icon: "🎬",
    label: "Reels",
    ariaLabel: "Reels",
    routePath: "reels",
  },
  {
    icon: "💬",
    label: "Connections",
    ariaLabel: "Messages",
    routePath: "messages",
  },
  { icon: "🏀", label: "Matches", ariaLabel: "Matches", routePath: "matches" },
  // {
  //   icon: "🥅",
  //   label: "Facilities",
  //   ariaLabel: "Facilities",
  //   routePath: "facilities",
  // },
  { icon: "👤", label: "Profile", ariaLabel: "Profile", routePath: "profile" },
];
function NavigationMenu() {
  const { unreadCount } = useContext(NotificationContext);
  const location = useLocation();

  return (
    <nav className={styles.navigationMenu}>
      {menuItems.map((item, index) =>
        item.label === "Notification" ? (
          <NavLink
            to={`/${item.routePath}`}
            className={({ isActive }) =>
              `${styles.menuItem} ${isActive ? styles.activeMenuItem : ""} ${
                item.mode === "mobile" ? styles.mobileOnly : ""
              }`
            }
            style={{ textDecoration: "none", color: "inherit" }}
            key={index}
            aria-label={item.ariaLabel}
          >
            {location.pathname.includes("notification") ? (
              <span
                className={styles.menuIcon}
                role="img"
                aria-hidden="true"
                style={{ marginRight: "10px" }}
              >
                {item.icon}
                {unreadCount > 0 && (
                  <span className={styles.notificationBadge}>
                    {unreadCount}
                  </span>
                )}
              </span>
            ) : unreadCount === 0 ? (
              <span
                className={styles.menuIcon}
                role="img"
                aria-hidden="true"
                style={{ marginRight: "10px" }}
              >
                {item.icon}
                {unreadCount > 0 && (
                  <span className={styles.notificationBadge}>
                    {unreadCount}
                  </span>
                )}
              </span>
            ) : (
              <span
                className={styles.menuIcon}
                role="img"
                aria-hidden="true"
                style={{ marginRight: "-9px" }}
              >
                {item.icon}
                {unreadCount > 0 && (
                  <span className={styles.notificationBadge}>
                    {unreadCount}
                  </span>
                )}
              </span>
            )}

            <span className={styles.menuLabel}>{item.label}</span>
          </NavLink>
        ) : (
          // Render other menu items as before
          <NavLink
            to={`/${item.routePath}`}
            className={({ isActive }) =>
              `${styles.menuItem} ${isActive ? styles.activeMenuItem : ""} ${
                item.mode === "mobile"
                  ? styles.mobileOnly
                  : styles.handleMobileAlgin
              }`
            }
            style={{ textDecoration: "none", color: "inherit" }}
            key={index}
            aria-label={item.ariaLabel}
          >
            {item.label === "Facilities" ? (
              <img
                src={stadium}
                className={styles.menuIcon}
                style={{ height: "20px", width: "25px" }}
              />
            ) :
            item.label === "Connections" ? (
              <img
                src={communities}
                className={styles.menuIcon}
                style={{ height: "25px", width: "25px" }}
              />
            )
            : (
              <span
                className={styles.menuIcon}
                role="img"
                aria-hidden="true"
                style={{ display: "flex" }}
              >
                {item.icon}
              </span>
            )}

            <span className={styles.menuLabel}>{item.label}</span>
          </NavLink>
        )
      )}
    </nav>
  );
}

export default NavigationMenu;
